"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePreviousValues = usePreviousValues;
var _react = require("react");
// keeps track of all unique previous values
// it's up to the user to add previous values
function usePreviousValues(initialValues = []) {
  const previousValues = (0, _react.useRef)(initialValues !== null && initialValues !== void 0 ? initialValues : []);
  const addPreviousValue = (0, _react.useCallback)(newValue => {
    if (previousValues.current.length === 0 || previousValues.current[previousValues.current.length - 1] !== newValue) {
      previousValues.current = [...previousValues.current, newValue];
    }
  }, [previousValues]);
  const getPreviousValue = (0, _react.useCallback)(allowDuplicates => {
    if (previousValues.current.length > 1 && !allowDuplicates) {
      return previousValues.current[previousValues.current.length - 2];
    }
    if (previousValues.current.length > 0) {
      return previousValues.current[previousValues.current.length - 1];
    }
    return undefined;
  }, [previousValues]);
  return {
    addPreviousValue,
    getPreviousValue
  };
}